import { useEffect, memo } from 'react';
import { Box, Typography } from '@mui/material';
import { StepperResetButtons } from './StepperButtons';
import ReactPixel from 'react-facebook-pixel';

/**
 * Shows the final confirmation screen once the user finishes checkout.
 *
 * Props
 * -----
 * data: {
 *   cardPaymentIntent?: { amount: number }
 * }
 * stepperProps: any – props forwarded to the stepper navigation controls.
 */
const RegisterComplete = ({ data, stepperProps }) => {
  // Track the successful purchase once the component is mounted.
  useEffect(() => {
    ReactPixel.track('Purchase', {
      value: 1495.0,
      currency: 'USD',
    });
  }, []);

  const amount = data?.cardPaymentIntent?.amount
    ? data.cardPaymentIntent.amount / 100
    : null;

  return (
    <>
      <Box sx={{ px: 2 }}>
        <Typography variant="body1" gutterBottom>
          Your transaction has been completed. Welcome to the retreat.
        </Typography>

        {amount && (
          <Typography variant="body2">
            {`Your card has been charged the ${amount.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })} down payment.`}
          </Typography>
        )}
      </Box>

      <StepperResetButtons {...stepperProps} />
    </>
  );
};

export default memo(RegisterComplete);